import { render, staticRenderFns } from "./FiltrosOfertas.vue?vue&type=template&id=0c147899"
import script from "./FiltrosOfertas.vue?vue&type=script&lang=js"
export * from "./FiltrosOfertas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports